export default function dataAdd(way,value,like = null){  
    
this.dataArrayAdd([{way:way,value:value,like:like}])

}